export default __webpack_public_path__ + "static/media/cs-block-1-alt.c02cb3c1.png";